/* eslint-disable no-unused-vars */
import notifyApi from '@/plugin/notifyApi';

const GET_NOTIFICATION_DELAY = 10000;

const REQUEST_RESULT = {
  SUCCESS: 'SUCCESS',
  FAIL: 'FAIL'
};

const ACTION_MAP = {
  created: ['CREATE_RULE'],
  updated: ['UPDATE_RULE', 'UPDATE_AGENT'],
  deleted: ['DELETE_RULE'],
  installed: ['INSTALL_AGENT'],
  removed: ['REMOVE_AGENT'],
  started: ['START_AGENT'],
  stopped: ['STOP_AGENT']
};

const REQUEST_TYPE_MAP = {
  event: ['CREATE_RULE', 'UPDATE_RULE', 'DELETE_RULE'],
  agent: ['UPDATE_AGENT', 'INSTALL_AGENT', 'REMOVE_AGENT', 'START_AGENT', 'STOP_AGENT']
};

const HAS_MORE_NOTIFICATIONS = {
  YES: 'Y',
  NO: 'N'
};

const notifyStore = {
  namespaced: true,
  state: () => ({
    hasNotifications: HAS_MORE_NOTIFICATIONS.YES,
    notificationItems: [],
    internalId: 0,
    chunkNotificationId: 0
  }),
  getters: {
    hasNotifications: (state) => state.hasNotifications,
    notificationItems: (state) => state.notificationItems,
    internalId: (state) => state.internalId
  },
  mutations: {
    updateNotificationItems: (state, items) => (state.notificationItems = items),

    updateNotifyStatus: (state, status) => (state.hasNotifications = status),

    clearNotificationItems: (state) => {
      state.internalId = 0;
      state.notificationItems = [];
    },

    updateInternalId: (state, id) => (state.internalId = id),
    updateChunkNotificationId: (state, id) => (state.chunkNotificationId = id)
  },
  actions: {
    setNotificationsInterval: ({ dispatch, commit }) => {
      dispatch('getNotifications');
      const internalId = setInterval(() => dispatch('getNotifications'), GET_NOTIFICATION_DELAY);
      commit('updateInternalId', internalId);
    },

    updateChunkNotificationId: ({ commit }, id) => {
      commit('updateChunkNotificationId', id);
    },

    markNotificationAsRead: ({ commit }, items) => {
      return notifyApi.notify.markNotificationAsRead(items.map((item) => item.requestTargetSq));
    },

    getNotifications: ({ commit, state }) => {
      if (state.hasNotifications === HAS_MORE_NOTIFICATIONS.NO) return;

      notifyApi.notify.getNotifications().then((data) => {
        if (data.hasNotifications) {
          commit('updateNotifyStatus', data.hasNotifications.toUpperCase());
        }

        if (data.notificationList) {
          const notifications = transformMessage(data.notificationList);
          commit('updateNotificationItems', notifications);
        }

        if (state.hasNotifications === HAS_MORE_NOTIFICATIONS.NO) clearInterval(state.internalId);
      });
    },

    needCheckNotifications: ({ commit, dispatch, state }, forceCheck = false) => {
      if (!forceCheck && state.hasNotifications === HAS_MORE_NOTIFICATIONS.YES) return;

      dispatch('resetNotification');
      commit('updateNotifyStatus', HAS_MORE_NOTIFICATIONS.YES);
      dispatch('setNotificationsInterval');
    },

    stopFetchingNotification: ({ commit, dispatch }) => {
      dispatch('resetNotification');
      commit('updateNotifyStatus', HAS_MORE_NOTIFICATIONS.NO);
    },

    resetNotification: ({ state, commit }) => {
      clearInterval(state.internalId);
      clearInterval(state.chunkNotificationId);
      commit('clearNotificationItems');
    }
  }
};

const transformMessage = (notificationList) => {
  return notificationList.map((item) => {
    let langKey = 'toast.async.';

    for (const [key, value] of Object.entries(ACTION_MAP)) {
      if (value.includes(item.requestType)) {
        langKey += key;
        break;
      }
    }

    for (const [key, value] of Object.entries(REQUEST_TYPE_MAP)) {
      if (value.includes(item.requestType)) {
        langKey += '.' + key;
        break;
      }
    }

    switch (item.requestResult.toUpperCase()) {
      case REQUEST_RESULT.SUCCESS:
        langKey += '_success';
        break;
      case REQUEST_RESULT.FAIL:
        langKey += '_fail';
        break;
      default:
        break;
    }

    return {
      langKey,
      name: item.monName,
      requestTargetSq: item.requestTargetSq
    };
  });
};

export default notifyStore;
